import { method, result } from "lodash";
import axios from "./Axios";
import { fetchWrapper } from "utils/apiFetch";
import { useSession } from "hooks/useSession";

const BASE_URL = "https://pro.mokshiq.in";


const URL = {
  AUTH: {
    LOGIN: {
      SEND_OTP: {
        url: "/login_request",
      },
      VERIFY_OTP: {
        url: "/login_with_otp",
      },
    },
    REGISTER: {
      url: "/register_api",
    },
    ForgotpasswordRequest: {
      url: "/send_forgot_password_request",
    },
    ResetPassword:{
      url:"/reset_password"
    }
  },
  MONEY_TRANSFER_ACTION: {
    url: "/money_transfer_action",
  },
};

export async function sendOtp(reqObj) {
  try {
    const res = await fetch(
      `${BASE_URL + URL.AUTH.LOGIN.SEND_OTP.url}`,
      {
        method: "POST",
        body: reqObj,
      }
    );
    const data = await res.json().catch(() => null);
    if (!res.ok) {
      return {
        status: false,
        message: data?.message || data?.error || `Server responded with status ${res.status}`,
        data,
      };
    }
    return data;
  } catch (error) {
    throw error;
  }
}
export async function sendForgotOtpReq(reqObj) {
  try {
    const res = await axios.post(
      `${BASE_URL + URL.AUTH.ForgotpasswordRequest.url}`,
      reqObj
    );
    return res.data;
  } catch (error) {
    throw error;
  }
}
export async function reSendOtp(reqObj) {
  try {
    const res = await fetch(
      `${BASE_URL + URL.AUTH.LOGIN.SEND_OTP.url}`,
      {
        method: "POST",
        body: reqObj,
      }
    );
    const data = await res.json().catch(() => null);
    if (!res.ok) {
      return {
        status: false,
        message: data?.message || data?.error || `Server responded with status ${res.status}`,
        data,
      };
    }
    return data;
  } catch (error) {
    throw error;
  }
}

export async function verifyOTP(reqObj) {
  try {
    const res = await fetch(
      `${BASE_URL + URL.AUTH.LOGIN.VERIFY_OTP.url}`,
      {
        method: "POST",
        body: reqObj,
      }
    );
    const data = await res.json().catch(() => null);
    if (!res.ok) {
      return {
        status: false,
        message: data?.message || data?.error || `Server responded with status ${res.status}`,
        data,
      };
    }
    return data;
  } catch (error) {
    throw error;
  }
}
export async function resetPasswordService(reqObj){
  try {
    const res = await axios.post(
      `${BASE_URL + URL.AUTH.ResetPassword.url}`,
      reqObj
    );
    return res.data;
  } catch (error) {
    throw error;
  }
}

export async function registerUser(reqObj) {
  try {
    const res = await axios.post(`${BASE_URL + URL.AUTH.REGISTER.url}`, reqObj);
    return res.data;
  } catch (error) {
    throw error;
  }
}
export async function fetchuserProfile(userid){
  try {
   
    const response = await fetchWrapper(
      `https://pro.mokshiq.in/get_user_profile?user=${userid}`
    );
   return response.data;
  } catch (err) {
   throw err
  } 
};

export async function moneyTransferAction(reqObj, url) {
  try {
    const res = await axios.post(
      `https://pro.mokshiq.in/${url}`,
      reqObj
    );
    return res.data;
  } catch (error) {
    debugger;
    return {
      status: false,
      error: error,
    };
  }
}

export async function getAllBanks() {
  try {
    const res = await axios.get(
      "https://pro.mokshiq.in/paysprint_dmt_bank_list"
    );

    return res?.data;
  } catch (error) {
    throw error;
  }
}
